<template>
  <article class="card" :class="{ _constructor: isConstructor }">
    <div class="card__inner">
      <div
        class="base-label"
        v-if="card.badges && card.badges[0]"
        :style="`background-color:${card.badges[0].color}`"
      >
        {{ card.badges[0].name }}
      </div>
      <router-link :title="card.name" :to="computedLink" class="card__img-wrap">
        <img :src="card.image_preview" :alt="card.name"/>
      </router-link>

      <div class="card__content">
        <h4 class="card__title">
          <router-link :to="computedLink">{{ card.name }}</router-link>
        </h4>
        <div
          class="card__variants"
          v-if="!isConstructor && card.variants && card.variants.length > 1"
        >
          <button
            v-for="(item, index) in card.variants"
            :key="index"
            :class="{ _active: selectedVariant === item }"
            @click.prevent="onSelectVariant(item)"
            type="button"
            class="card__variants-item base-btn"
          >
            {{ item.name }}
          </button>
        </div>
        <BaseSelect
          v-if="!isConstructor && card.properties && card.properties.length > 1"
          v-model="propertySelected"
          :options="card.properties"
          textKey="property"
          class="card__select"
        />
        <div v-if="card.description" class="card__subs">
          <div class="card__subs-inner">
            {{ stripHtml(card.description) }}
          </div>
        </div>

        <div class="card__price-wrap price" v-if="!isConstructor">
          <div class="price__val">
            <span v-if="card.weight_dish">{{ $t("від") }}</span>
            {{ (((selectedVariant && selectedVariant.price) || 0) * quantity) | formatPrice }}
            {{ $t("грн") }}
          </div>
          <span class="card__subs-weight" v-if="card.weight">/ {{ card.weight }}</span>
        </div>
      </div>

      <div class="card__footer">
        <router-link v-if="isConstructor" :to="computedLink" class="card__btn base-btn _black">
          {{ $t("Зібрати піцу") }}
        </router-link>

        <template v-else>
          <Quantity v-model="quantity" class="card__quantity"/>

          <button
            type="button"
            class="card__btn base-btn _black"
            @click="addToBasket"
            :title="`${$t('Замовити')} ${card.name}`"
          >
            {{ $t("Замовити") }}
          </button>
        </template>
      </div>
      <AddToBasket :quantity="quantity" ref="add-el"/>
    </div>
  </article>
</template>

<script>
import {mapActions} from "vuex";
import Quantity from "./Quantity";
import stripHtml from "@/helpers/stripHtml";
import {addToBasketAnimation} from "@/helpers/addToBasketAnimation";
import AddToBasket from "@/components/AddToBasket";
import ca from "vue2-datepicker/locale/es/ca";

export default {
  name: "Card",
  components: {AddToBasket, Quantity},
  props: {
    card: {
      type: Object,
      required: true,
    },
    isConstructor: {
      type: Boolean,
    },
  },
  data() {
    return {
      stripHtml,
      selectedVariant: null,
      quantity: 1,
      propertySelected: null,
    };
  },
  computed: {
    ca() {
      return ca;
    },
    computedLink() {
      return this.isConstructor
        ? {
          name: "product",
          params: {id: 'classic', slug: 'classic'},
        }
        : {
          name: "product",
          params: {id: this.card.id, slug: this.card.slug},
        };

    },
  },
  methods: {
    ...mapActions("basket", ["addProductToBasket"]),
    onSelectVariant(variant) {
      this.selectedVariant = variant;
    },
    setDefault() {
      if (this.card.properties && this.card.properties.length) {
        this.propertySelected = this.card.properties[0];
      }
      if (this.card.variants && this.card.variants.length) {
        this.onSelectVariant(this.card.variants[0]);
      }
    },
    addToBasket(event) {
      const cardObj = {
        type: this.card.type,
        product: this.card,
        quantity: this.quantity,
        variant: this.selectedVariant || null,
        property: this.propertySelected || null,
        main_ingredients: null,
        additional_ingredients: null,
        comment: null,
      };

      addToBasketAnimation(event, this.$refs["add-el"].$el, () => {
        this.addProductToBasket(cardObj);
      });
    },
  },
  created() {
    this.setDefault();
  },
};
</script>

<style></style>
